<template>
  <v-card width="100%">
    <management-nav />
    <v-card-title>
      Kursy do warsztatów
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Szukaj" single-line hide-details
        ><font-awesome-icon
          icon="search"
          slot="prepend-inner"
          class="mt-1 mr-1"
      /></v-text-field>
    </v-card-title>
    <v-data-table
      :loading="!items"
      loading-text="Trwa pobieranie danych..."
      :headers="headers"
      :items="items"
      :search="search"
    >
      <template v-slot:no-data>
        <v-alert :value="items && items.length === 0">
          Brak kursów w subskrypcjach miesięcznych
        </v-alert>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="green"
              @click="editPackage(item)"
              v-bind="attrs"
              v-on="on"
              v-on:click="isModalVisible = true"
            >
              <font-awesome-icon icon="edit" />
            </v-btn>
          </template>
          <span>Edytuj</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              @click="(isDeleteModalVisible = true), (packageItemData = item)"
              v-bind="attrs"
              v-on="on"
            >
              <font-awesome-icon icon="times" />
            </v-btn>
          </template>
          <span>Usuń</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="orange"
              @click="copyPackage(item)"
              v-bind="attrs"
              v-on="on"
              v-on:click="isModalVisible = true"
            >
              <font-awesome-icon icon="copy" />
            </v-btn>
          </template>
          <span>Kopiuj</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.photo`]="{ item }">
        <template>
          <img
            class="item-image"
            :id="item.imagePath"
            @click="editPackage(item)"
            v-on:click="isModalVisible = true"
            alt="
              joga zdrowy,
              filmy jogi,
              techniki oddechowe,
              praktyka wzmacniająca,
              joga online,
              praktyka dla początkujących,
              szkoła online,
              prana vyavama,
              joga wzmacniająca,
              joga video,
              ćwiczenia online,
              uważna praktyka,
              anatomia jogi
              "
            loading="lazy"
          />
        </template>
      </template>
      <template v-slot:[`item.timePackage`]="{ item }">
        <template>
          <p
            :id="item.time_package.id"
            v-html="htmlToFormattedText(item.time_package.name)"
          />
        </template>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <template>
          <p :id="item.id" v-html="htmlToFormattedText(item.name)" />
        </template>
      </template>
      <template v-slot:[`item.description`]="{ item }">
        <template>
          <p :id="item.id" v-html="htmlToFormattedText(item.description)" />
        </template>
      </template>
    </v-data-table>
    <AddWorkshopsItemModal
      :isVisible="isModalVisible"
      :packageItemData="packageItemData"
      @closeModal="closeModal()"
      @updated="timePackageUpdated()"
    />
    <before-delete-modal
      :isVisible="isDeleteModalVisible"
      @closeModal="closeDeleteModal()"
      @confirmDeletion="confirm(packageItemData.id)"
    />
    <v-btn
      fab
      dark
      large
      color="green"
      fixed
      left
      bottom
      @click="addWorkshopsItem()"
    >
      <font-awesome-icon icon="plus" />
    </v-btn>
  </v-card>
</template>

<script>
import AddWorkshopsItemModal from "../components/modals/AddWorkshopsItemModal";
import ManagementNav from "../components/ManagementNav.vue";
import { SERVER_URL } from "../axios";
import BeforeDeleteModal from "../components/modals/BeforeDeleteModal.vue";

export default {
  name: "WorkshopsItems",
  components: {
    AddWorkshopsItemModal,
    ManagementNav,
    BeforeDeleteModal,
  },

  async mounted() {
    await this.$store.dispatch("timePackages/fetchWorkshopsItems");
    this.loadImages();
  },
  data: () => ({
    headers: [
      { text: "Nazwa kursu", value: "name" },
      { text: "Nazwa warsztatu", value: "timePackage" },
      { text: "Opis", value: "description" },
      { text: "Link YouTube", value: "link" },
      { text: "Link Dropbox", value: "linkDropbox" },
      { text: "Zdjęcie", value: "photo" },
      { text: "Akcje", value: "actions", sortable: false },
    ],
    search: "",
    isModalVisible: false,
    packageItemData: null,
    loadingImages: false,
    isDeleteModalVisible: false,
  }),
  computed: {
    items() {
      return this.$store.getters["timePackages/getWorkshopsItems"];
    },
  },
  methods: {
    confirm(id) {
      this.deletePackage(id);
    },
    closeDeleteModal() {
      this.isDeleteModalVisible = false;
      this.packageItemData = null;
    },
    addWorkshopsItem() {
      this.packageItemData = null;
      this.isModalVisible = true;
    },
    copyPackage(data) {
      this.packageItemData = data;
      this.packageItemData.copy = true;
      this.packageItemData.copiedTimePackageItemId = data.id;
    },
    htmlToFormattedText(text) {
      const regex =
        /((http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(\/\S*)?)/g;
      text = text.replace(regex, '<a href="$1">$1</a>');
      return text;
    },
    timePackageUpdated() {
      this.loadImages();
    },
    async loadImages() {
      this.items.forEach(async (item) => {
        this.loadImage(item);
      });
    },

    async loadImage(timePackageItem) {
      const element = document.getElementById(timePackageItem.imagePath);
      if (element) {
        if (timePackageItem.imagePath) {
          const extension = timePackageItem.imagePath?.split(".")[1];
          element.src = `${SERVER_URL}${
            timePackageItem.id
          }.${extension}?${new Date().getTime()}`;
        }
      }
    },

    editPackage(data) {
      this.packageItemData = data;
    },
    deletePackage(id) {
      this.$store.dispatch("timePackages/deleteTimePackageItem", {
        id,
        type: "WORKSHOPS",
      });
    },
    closeModal() {
      this.isModalVisible = false;
      this.packageItemData = null;
    },
  },
};
</script>

<style scoped>
.item-image {
  width: 130px;
  height: 130px;
  border-radius: 1rem;
  margin: 1rem;
}
</style>
